import { ActivityIndicator, ActivityIndicatorProps } from 'react-native'
import styled, { useTheme } from 'styled-components/native'

const LoadingContainer = styled.View`
  position: absolute;
  justify-content: center;
  align-items: center;
  z-index: 1;
  background: #00000077;
  height: 100%;
  width: 100%;
`

export const LoadingOverlay = (props: ActivityIndicatorProps) => {
  const theme = useTheme()

  return (
    <LoadingContainer>
      <ActivityIndicator
        size="large"
        color={theme.colors.text}
        testID="LOADING_OVERLAY"
        {...props}
      />
    </LoadingContainer>
  )
}
